import { getFinancialYearLabels } from "../../brsrFinancialYearLabels";
import {
  BODY_FONT,
  HEADER_FONT_11,
  HEADER_FONT_12,
  HEADER_ROW,
  VALUE_FILL,
  setCell,
} from "./detailSheetCommon.js";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  addPrinciple2BackLink,
  addSheetTitle,
  addTableSpacer,
  applyBorderPattern,
  displayText,
  formatPercent,
  setupPrinciple2DetailSheet,
  writeDataRow,
  hideRowsThrough,
} from "./principle2DetailHelpers.js";

const SHEET_TITLE =
  "Percentage of recycled or reused input material to total material (by value) used in production or providing services";

export const SHEET_NAME = "Recycled or reused input";

const WIDTHS = {
  A: 9.1796875,
  B: 9.1796875,
  C: 9.1796875,
  D: 9.1796875,
  E: 45.7265625,
  F: 67.54296875,
  G: 45.7265625,
  H: 9.1796875,
  I: 9.1796875,
  J: 9.1796875,
};

const SUB_HEADER_ROW = HEADER_ROW + 1;
const TEMPLATE_ROW = 11;
const SPACER_ROW = 12;
const DATA_START_ROW = 13;

export function buildRecycledOrReusedInputSheet(workbook, sectionC, reportingYear = "") {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: false }] });
  const fy = getFinancialYearLabels(reportingYear);
  const fyCurrent = fy.currentYear ? `FY (${fy.currentYear})` : "FY (Current Financial Year)";
  const fyPrevious = fy.previousYear ? `PY (${fy.previousYear})` : "PY (Previous Financial Year)";
  const colEnd = COL_G;

  setupPrinciple2DetailSheet(ws, {
    widths: WIDTHS,
    colEnd,
    ySplit: 12,
    topLeftCell: "D13",
    lastVisibleCol: 10,
    xSplit: 3,
  });
  addPrinciple2BackLink(ws, colEnd);
  addSheetTitle(ws, colEnd, SHEET_TITLE);

  applyBorderPattern(ws, HEADER_ROW, COL_D, ["tttt", "tttt", "tttt", "tttt"]);
  ws.getRow(HEADER_ROW).height = 15.5;
  setCell(ws, HEADER_ROW, COL_D, "Sr. No.", {
    font: HEADER_FONT_11,
    bordered: false,
    align: "center",
  });
  setCell(ws, HEADER_ROW, COL_E, "Indicate input material", {
    font: HEADER_FONT_12,
    bordered: false,
    align: "center",
  });
  ws.mergeCells(HEADER_ROW, COL_F, HEADER_ROW, COL_G);
  setCell(ws, HEADER_ROW, COL_F, "Recycled or re-used input material to total material", {
    font: HEADER_FONT_12,
    bordered: false,
    align: "center",
  });

  applyBorderPattern(ws, SUB_HEADER_ROW, COL_D, ["tttt", "-ttt", "-ttt", "-ttt"]);
  ws.getRow(SUB_HEADER_ROW).height = 15.5;
  setCell(ws, SUB_HEADER_ROW, COL_F, fyCurrent, {
    font: HEADER_FONT_12,
    bold: true,
    bordered: false,
    align: "center",
  });
  setCell(ws, SUB_HEADER_ROW, COL_G, fyPrevious, {
    font: HEADER_FONT_12,
    bold: true,
    bordered: false,
    align: "center",
  });
  ws.mergeCells(HEADER_ROW, COL_D, SUB_HEADER_ROW, COL_D);
  ws.mergeCells(HEADER_ROW, COL_E, SUB_HEADER_ROW, COL_E);

  applyBorderPattern(ws, TEMPLATE_ROW, COL_D, ["tttt", "-ttt", "-ttt", "-ttt"]);
  for (let col = COL_D; col <= colEnd; col += 1) {
    setCell(ws, TEMPLATE_ROW, col, "", { bordered: false, font: BODY_FONT });
  }
  ws.getRow(TEMPLATE_ROW).height = 15.5;
  ws.getRow(TEMPLATE_ROW).hidden = true;

  addTableSpacer(ws, COL_D, colEnd, { row: SPACER_ROW });

  const rows = Array.isArray(sectionC?.principle2?.leadershipIndicator?.recycledOrReusedMaterial)
    ? sectionC.principle2.leadershipIndicator.recycledOrReusedMaterial
    : [];
  const dataRows = rows.length ? rows : [{}];

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    writeDataRow(ws, row, COL_D, colEnd, [
      { col: COL_D, value: String(idx + 1), align: "center", fill: undefined, font: BODY_FONT },
      { col: COL_E, value: displayText(item?.indicateInputMaterial), align: "left", fill: VALUE_FILL },
      { col: COL_F, value: formatPercent(item?.currentFinancialYear), align: "center", fill: VALUE_FILL },
      { col: COL_G, value: formatPercent(item?.previousFinancialYear), align: "center", fill: VALUE_FILL },
    ], {
      patterns: ["tttt", "-ttt", "-ttt", "-ttt"],
    });
    ws.getRow(row).height = 15.5;
  });

  hideRowsThrough(ws, 5);
  return ws;
}
